import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
var DialogHeader = styled.div.withConfig({
  displayName: "Headerstyles__DialogHeader",
  componentId: "sc-1npjr8r-0"
})(["background:var(--dentsu-color-white);padding:var(--dentsu-spacing-24);border-radius:0;display:flex;align-items:flex-start;font-family:var(--dentsu-font-family-sans);text-align:left;+ .", "-dialog__body{padding:0 var(--dentsu-spacing-24) var(--dentsu-spacing-24);}.", "-dialog--modal &{padding:var(--dentsu-spacing-16) var(--dentsu-spacing-24) var(--dentsu-spacing-12);border-bottom:1px solid var(--dentsu-color-n150);+ .", "-dialog__body{padding:var(--dentsu-spacing-32) var(--dentsu-spacing-48);}}"], prefix, prefix, prefix);
var StatusIcon = styled.div.withConfig({
  displayName: "Headerstyles__StatusIcon",
  componentId: "sc-1npjr8r-1"
})(["line-height:1;margin-top:1px;margin-right:var(--dentsu-spacing-8);"]);
var Title = styled.div.withConfig({
  displayName: "Headerstyles__Title",
  componentId: "sc-1npjr8r-2"
})(["flex:1;"]);
var Metadata = styled.h4.withConfig({
  displayName: "Headerstyles__Metadata",
  componentId: "sc-1npjr8r-3"
})(["font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-regular);color:var(--dentsu-color-n700);line-height:var(--dentsu-leading-tight);"]);
var Heading = styled.h3.withConfig({
  displayName: "Headerstyles__Heading",
  componentId: "sc-1npjr8r-4"
})(["color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-semibold);line-height:var(--dentsu-leading-tight);margin:0;padding:0;overflow:visible;text-overflow:inherit;white-space:normal;&:last-child{margin-right:0;}"]);
var CloseButton = styled.button.withConfig({
  displayName: "Headerstyles__CloseButton",
  componentId: "sc-1npjr8r-5"
})(["border:none;background:none;outline:none;&:hover{cursor:pointer;.", "-icon{color:var(--dentsu-color-n850);}}.", "-icon{color:var(--dentsu-color-blue);margin-right:0;}"], prefix, prefix);
export var Styled = {
  CloseButton: CloseButton,
  DialogHeader: DialogHeader,
  Heading: Heading,
  Metadata: Metadata,
  StatusIcon: StatusIcon,
  Title: Title
};